import './index.css';

export default {
  name: 'Acount',
  props: {
    id: { type: String, default: () => (`a-count-${Math.random().toString().substring(2)}`) },
    locale: { type: Boolean, default: () => false },
    speed: { type: String | Number, default: () => 3000 },
    value: { type: String | Number, default: () => null },
    number: { type: String | Number, default: () => null },
    content: { type: String | Number, default: () => null },
  },
  data() {
    return ({
      count: 0,
      float: '',
      animation: null,
    });
  },
  watch: {
    value() { this.create() },
    number() { this.create() },
    content() { this.create() },
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      const count = this.value || this.number || this.content || 0;
      this.$nextTick(() => {
        this.count = Number(count);
        this.$nextTick(() => {
          const string = (`${this.count}`);
          if (string.indexOf('.') !== -1) {
            const float = string.substring(string.indexOf('.'))
            this.float = `<b class="a-count-value float">${float}</b>`;
          }
          this.$nextTick(() => this.runing());
        });
      });
    },
    runing() {
      this.cancel();
      this.$nextTick(() => {
        let startTime = null;
        const animation = () => {
          const timestamp = new Date().valueOf();
          if (!startTime) startTime = timestamp;
          const progress = Math.min((timestamp - startTime) / parseInt(this.speed), 1);
          const digit = Math.floor(progress * this.count);
          const value = (this.locale ? digit.toLocaleString() : digit);
          const array = (`${value}`).split('');
          const text = array.map((a, b) => (`<b class="a-count-value item-${b}${isNaN(a) ? ' symbol' : ''}">${a}</b>`));
          const html = text.join('');
          this.$el.innerHTML = html;
          if (progress < 1) {
            this.animation = requestAnimationFrame(animation);
          } else {
            this.$el.innerHTML += this.float;
          }
        };
        animation();
      });
    },
    cancel() {
      if (this.animation) {
        cancelAnimationFrame(this.animation);
        this.animation = null;
      }
    },
    revoke() {
      this.cancel();
      this.$nextTick(() => {
        this.float = '';
        this.$nextTick(() => this.count = 0);
      });
    },
  },
  render() {
    return (<span id={this.id} class={['a-count', (this.locale ? 'locale' : null), `length-${(`${this.count}`).length}`]} />);
  },
}